var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoinHands(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "216px",
    height: "216px",
    viewBox: "0 0 216 216",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D816DF8F-2669-418F-BAF7-7A90F8F93872@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My-account-\\u2705",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01B---My-Account---Premium-access",
    transform: "translate(-79.000000, -595.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(0.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(20.000000, 539.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(59.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0,
    fill: "#FFFFFF",
    cx: 108,
    cy: 108,
    r: 108
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFF3DB",
    cx: 108,
    cy: 108,
    r: 68
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-163",
    transform: "translate(58.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8155,100.91181 L33.5,102.991748 C28.52675,105.992393 22.46575,105.458097 19.25,100.606498 C18.53275,99.5283651 18.03875,98.2880351 17.68725,97 C10.31525,99.6237751 5,106.617329 5,114.917999 C5,125.456034 13.50725,134 24,134 C34.49275,134 43,125.456034 43,114.917999 C43,109.360366 40.59175,104.399046 36.8155,100.91181 L36.8155,100.91181 Z",
    id: "Stroke-159",
    stroke: "#17243D",
    strokeWidth: 2,
    fill: "#25D086",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3530223,91.4419505 L2.2451927,67.9746928 C-0.990202888,63.9664851 -0.496428852,60.2492715 2.2451927,56.2410639 L16.3530223,35.1205319 C17.7167792,32.8489014 18.5679516,31.3610773 21.0556322,30.4270804 L61.0278161,14 L101,35.1205319 C101,35.1205319 94.6796923,47.8069315 82.1895605,67.9746928 C69.6994287,88.142454 51.6225964,91.4419505 51.6225964,91.4419505 L32.8121569,103.175579 C27.8885243,106.12776 21.8879941,105.602094 18.7043273,100.828854 C15.356069,95.8162473 15.9627057,87.6355613 21.0556322,84.4017732 C29.0970951,79.2906044 40.7031362,72.6681443 42.2173766,72.6681443 C42.2173766,70.1946953 46.2051898,61.6479201 51.6225964,56.2410639 C41.2439364,56.2410639 35.1634618,49.2008866 35.1634618,49.2008866 C35.1634618,52.9603413 21.6434584,63.2812412 18.7043273,63.2812412 C18.7043273,63.2812412 23.4069371,66.3132109 23.4069371,72.6681443 C26.5294701,72.6681443 28.109547,79.7083216 28.109547,79.7083216",
    id: "Stroke-161",
    stroke: "#17243D",
    strokeWidth: 2,
    fill: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,0 L59,13.9878448 L105.666667,37.3009194 C109.544667,39.2405672 115,36.9698737 115,32.6383044 L115,18.6504597 L73,0 L73,0 Z",
    id: "Stroke-157",
    stroke: "#17243D",
    strokeWidth: 2,
    fill: "#FFD67E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8817262,79.5297924 C25.858851,75.6489225 24.5263389,73.7084876 22.88419,73.7084876 C21.8163534,73.7084876 16.2153663,75.3053087 14.2127694,76.6352947 C13.1465493,77.3434042 12.3249952,79.0379687 11.7481071,81.7189882 L16.2153663,88.8748192 L18.8668098,84.5689191 L26.8817262,79.5297924 Z",
    id: "Path-2",
    fill: "#F1F2F4"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F1F2F4",
    cx: 108,
    cy: 206,
    rx: 50,
    ry: 10
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinHands);
export default __webpack_public_path__ + "static/media/coin-hands.bef65849ca2f7e5ec634d42bf900871a.svg";
export { ForwardRef as ReactComponent };